import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";
import { EditInput } from "@fidget/common/components/form/editInput";
import { L10n } from "@fidget/common/i18n";
import { getUrlPlaceholder } from "@fidget/common/utils/urlMappingHelpers";
import { useStore } from "../../../../../../models";
import { TagPicker } from "../../../../../forms/tagPicker/tagPicker";
import { VerticalSeparator } from "../../../../settingsForms/separators/verticalSeparator/verticalSeparator";
import styles from "../../taggingSettings.css";
import { NewMappingFormType } from "../../types";
import { StrategyPicker } from "../strategyPicker/strategyPicker";

interface Props {
  form: NewMappingFormType;
  formRef: React.MutableRefObject<HTMLDivElement | null | undefined>;
}
export const NewMappingBox = observer(({ form, formRef }: Props) => {
  const { tagsStore } = useStore();
  const { matchingStrategy, tagId, urlPattern } = form.$;
  const isStrategyPicked = matchingStrategy.value.length !== 0;

  return (
    <div className={styles["form-content"]} ref={(el) => (formRef.current = el)}>
      <div className={classNames(styles["url-inputs-container"], styles["inputs-container"])}>
        <StrategyPicker field={matchingStrategy} initiallyOpen />
        {isStrategyPicked && (
          <div>
            <EditInput
              className={styles["bottom-input"]}
              value={urlPattern.value}
              onChange={(ev) => urlPattern.onChange((ev.target as HTMLInputElement).value)}
              hasError={urlPattern.hasError}
              errorHint={urlPattern.error}
              placeholder={getUrlPlaceholder(matchingStrategy.value)}
            />
          </div>
        )}
      </div>
      {isStrategyPicked && (
        <>
          <VerticalSeparator />
          <div className={classNames(styles["inputs-container"], styles["tag-input"])}>
            <div className={styles["form-text"]}>
              <L10n id={"settings.tagging.mapping.tag"} />
            </div>
            <div className={styles["bottom-input"]}>
              <TagPicker
                tagId={tagId.$}
                onChange={(tag) => tagId.reset(tag.id)}
                values={tagsStore.orgTagsWithoutSystem}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
});
